import { KeywordResearchTopKeywordsHomepage } from "app/pages/digital-marketing/KeywordResearchTopKeywords";

export const KeywordResearchTopKeywordsHomepageContainer = () => {
    return (
        <KeywordResearchTopKeywordsHomepage
            title={"digitalMarketing.findKeywords.TopKeywords.title"}
            subTitle={"digitalMarketing.findKeywords.TopKeywords.subTitle"}
        />
    );
};
